import ManagedError from './ManagedError.js';

function ServerError(statusCode, response) {

  this.name = 'ServerError';
  this.statusCode = statusCode;
  this.response = response;

  this.getStatusCode = function () {

    return this.statusCode;

  };

  this.getResponse = function () {

    return this.response;

  };

}

ServerError.prototype = Object.create(ManagedError.prototype);
ServerError.prototype.constructor = ServerError;

export default ServerError;



// WEBPACK FOOTER //
// ./src/library/domain/ServerError.js